import { PERMISSION } from '@/constants/permission.constant';

const colorList = () => import('@/views/configuration/colors/List.vue');
const colorAdd = () => import('@/views/configuration/colors/Add.vue');
const colorEdit = () => import('@/views/configuration/colors/Edit.vue');

export const colorRoute = [
  {
    path: '/configuration/colors',
    name: 'color',
    component: colorList,
    meta: { requiresAuth: false, permissions: [PERMISSION.COLOR_READ] },
  },

  {
    path: '/configuration/colors/create',
    name: 'color-create',
    component: colorAdd,
    meta: { requiresAuth: false, permissions: [PERMISSION.COLOR_CREATE] },
  },
  {
    path: '/configuration/colors/:id/edit',
    name: 'color-edit',
    component: colorEdit,
    meta: { requiresAuth: false, permissions: [PERMISSION.COLOR_UPDATE] },
  },
];
